import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsApiService } from '../../core/services/api/cms-api.service';
import { CmsContentMapperService } from '../../core/services/cms-content-mapper.service';
import { HttpStatus } from '../../core/services/response-handler.service';
import { decodeHexStr, isHexString } from '../../core/helpers/utils';
import { ContentUpdaterService } from '../../core/services/content-updater/content-updater.service';

export enum TemplateType {
  TEXT = 'text',
  ACCORDION = 'accordion'
}

@Injectable({
  providedIn: 'root',
})
export class StaticPageService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _contentUpdate = inject(ContentUpdaterService);

  /**
   * Get page item from CMS and prepare for using in frontend
   *
   * @param params
   */
  item(params: object = {}): Observable<any> {
    return this._contentUpdate.registerContent('page/item', params, () =>
      combineLatest([
        this._api.pageItem(params),
        // this._api.sysNotificationList({page_slug: params['slug']})
      ]).pipe(
        map(([page]) => {
          if (page.statusCode === HttpStatus.OK) {
            return this._mapper.mapCmsData(
              isHexString(page.data) ? [decodeHexStr(page.data)] : page.data, {
                slug: 'slug',
                template_slug: 'template.slug',
                publishAt: 'publishAt.date',
                unpublishAt: 'unpublishAt.date',
                name: 'name',
              });
          } else {
            return { statusCode: page.statusCode };
          }
        }),
      ),
    );
  }
}
